import { createFileRoute } from "@tanstack/react-router";
import AppLayout from "../../components/AppLayout";
import Footer from "../../components/Footer/Footer";
import { ThemeSlot } from "../../themes/slots";
import Orders from "../../screens/Orders";

export const Route = createFileRoute("/c/orders")({
  component: () => (
    <AppLayout>
      <ThemeSlot slot="header" isProfile={true} />
      <RouteComponent />
      <Footer />
    </AppLayout>
  ),
});

function RouteComponent() {
  return <Orders />;
}
